import { SingleColumnLayout } from "@/pages/campaign-form/components/layouts/SingleColumnLayout/SingleColumnLayout"
import { useStyles } from "@/pages/campaign-form/components/layouts/TwoColumnsLayout/TwoColumnsLayout.styles"
import { useMantineTheme } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import React from "react"

interface Props {
    children: any
    notResponsive?: boolean
    columnsWidth?: any
    singleColumnWidth?: any
    columnWidth?: any
}

/**
 * TwoColumnsLayout
 * @param children         Wrap each column into a div. Each div will be a column. Limit to 2 columns.
 * @param columnWidth      Width of each column.
 * @param notResponsive    If false, the layout will be responsive in terms of combining items from both columns into a singlo column.
 *                         If true, the layout will only hide the content of the second column.
 */
export const TwoColumnsLayout = ({ children, columnWidth, notResponsive = false }: Props) => {
    const theme = useMantineTheme()
    const breakpointWithoutMedia = theme.fn.largerThan("lg").replace("@media ", "")
    const windowAboveBreakpoint = useMediaQuery(breakpointWithoutMedia)
    const { classes } = useStyles({
        columnWidth: `${columnWidth}px`,
        isAboveBreackpoint: windowAboveBreakpoint,
    })

    return (
        <>
            {windowAboveBreakpoint && (
                <div id="twocolumnslayout-container" className={classes.columns}>
                    <div id="twocolumnslayout-left" className={classes.leftColumn}>
                        <SingleColumnLayout width={columnWidth - 16}>{children[0]}</SingleColumnLayout>
                    </div>
                    <div className={classes.divider}></div>
                    <div id="twocolumnslayout-right">
                        <SingleColumnLayout rightColumn width={columnWidth - 16}>
                            {children[1]}
                        </SingleColumnLayout>
                    </div>
                </div>
            )}
            {!windowAboveBreakpoint && !notResponsive && (
                <div id="twocolumnslayout-single" className={classes.singleColumn}>
                    <SingleColumnLayout width={columnWidth}>{children}</SingleColumnLayout>
                </div>
            )}
            {!windowAboveBreakpoint && notResponsive && (
                <div id="twocolumnslayout-single-notresponsive" className={classes.singleColumn}>
                    <SingleColumnLayout width={columnWidth}>{children[0]}</SingleColumnLayout>
                </div>
            )}
        </>
    )
}
